// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qytfmvfwrfsacwsgrpeu.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InF5dGZtdmZ3cmZzYWN3c2dycGV1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTc4NTc2NzgsImV4cCI6MjA3MzQzMzY3OH0.-gZzr0k5EaOjhF2y2wIkxgAxQRn9JgF1HwxbuxXYiLo";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});